import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Use httpOnly cookies for auth — no client-readable tokens.
const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

export const PROVINCES = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Nova Scotia",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Northwest Territories",
  "Nunavut",
  "Yukon",
];

export const TRADE_CATEGORIES = [
  "Handyman / General Repair",
  "Plumbing",
  "Electrical",
  "Roofing",
  "HVAC / Heating & Cooling",
  "Carpentry & Woodwork",
  "Painting (Interior / Exterior)",
  "Flooring",
  "Door & Window Repair",
  "Drywall & Plastering",
  "Landscaping & Outdoor",
  "Moving & Hauling",
  "Cleaning & Junk Removal",
  "Home Renovation (General)",
  "Smart Home / Tech Installation",
];

export const FEATURED_CITIES = [
  { name: "Toronto", province: "Ontario", img: "https://images.pexels.com/photos/25696388/pexels-photo-25696388.jpeg" },
  { name: "Calgary", province: "Alberta", img: "https://images.unsplash.com/photo-1502301197179-65228ab57f78?auto=format&fit=crop&w=900&q=70" },
  { name: "Vancouver", province: "British Columbia", img: "https://images.unsplash.com/photo-1559511260-66a654ae982a?auto=format&fit=crop&w=900&q=70" },
  { name: "Montreal", province: "Quebec", img: "https://images.unsplash.com/photo-1519178614-68673b201f36?auto=format&fit=crop&w=900&q=70" },
  { name: "Ottawa", province: "Ontario", img: "https://images.unsplash.com/photo-1610116390027-352d09a83fe5?auto=format&fit=crop&w=900&q=70" },
  { name: "Edmonton", province: "Alberta", img: "https://images.unsplash.com/photo-1572017083123-3a78ad3a5f43?auto=format&fit=crop&w=900&q=70" },
  { name: "Winnipeg", province: "Manitoba", img: "https://images.unsplash.com/photo-1572715381253-d2c5c7c25fcb?auto=format&fit=crop&w=900&q=70" },
  { name: "Halifax", province: "Nova Scotia", img: "https://images.unsplash.com/photo-1597762470488-3877b1f538c6?auto=format&fit=crop&w=900&q=70" },
];

export const URGENCIES = ["Flexible", "Within a Week", "ASAP"];
